module.exports = __webpack_public_path__ + "img/anewitem-furnitures.932ea6a8.svg";